import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../hooks/useContent';
import HeroSection from '../components/HeroSection';
import UeberUns from '../components/UeberUns';
import HighlightsList from '../components/HighlightsList';

export default function Startseite() {
  const { content, loading, error } = useContent();

  if (loading) return <div style={styles.loading}>Inhalte werden geladen...</div>;
  if (error) return <div style={styles.errorBox}>Inhalte konnten nicht geladen werden.<br /><small>{error}</small></div>;
  if (!content) return null;

  return (
    <main>
      <HeroSection
        heading={content.hero?.heading}
        subheading={content.hero?.subheading}
        image={content.hero?.heroImage}
      />

      <UeberUns
        heading={content.ueberUns?.heading}
        text={content.ueberUns?.text}
      />

      <HighlightsList highlights={content.highlights} />

      {/* Kontakt & CTA Bereich */}
      {content.contact && (
        <section style={styles.contactSection}>
          <div style={styles.contactInner}>
            <div style={styles.contactCard}>
              <h2 style={styles.contactHeading}>Kontakt & Anreise</h2>
              <div style={styles.contactGrid}>
                <div style={styles.contactInfo}>
                  <div style={styles.contactRow}>
                    <span style={styles.contactIcon}>📍</span>
                    <div>
                      <strong style={styles.contactLabel}>{content.contact.name}</strong>
                      <span style={styles.contactValue}>{content.contact.address}</span>
                    </div>
                  </div>
                  <div style={styles.contactRow}>
                    <span style={styles.contactIcon}>📞</span>
                    <div>
                      <strong style={styles.contactLabel}>Telefon</strong>
                      <a href={`tel:${content.contact.phone}`} style={styles.contactLink}>{content.contact.phone}</a>
                    </div>
                  </div>
               {/*    <div style={styles.contactRow}>
                    <span style={styles.contactIcon}>✉️</span>
                    <div>
                      <strong style={styles.contactLabel}>E-Mail</strong>
                      <a href={`mailto:${content.contact.email}`} style={styles.contactLink}>{content.contact.email}</a>
                    </div>
                  </div> */}
                  <div style={styles.contactRow}>
                    <span style={styles.contactIcon}>🌐</span>
                    <div>
                      <strong style={styles.contactLabel}>Website</strong>
                      <span style={styles.contactValue}>www.camping-spirkenhof.at</span>
                    </div>
                  </div>
                </div>
                <div style={styles.ctaBox}>
                  <p style={styles.ctaText}>Bereit für Ihren nächsten Urlaub?</p>
                  <Link to="/buchung" style={styles.ctaBtn}>Jetzt Buchungsanfrage stellen</Link>
                  <Link to="/galerie" style={styles.ctaBtnSecondary}>Galerie ansehen</Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.footerInner}>
          <p style={styles.footerText}>
            © {new Date().getFullYear()} Camping Spirkenhof 
          </p>
          <p style={{ ...styles.footerText, opacity: 0.5, marginTop: '0.3rem', fontSize: '0.8rem' }}>
            www.camping-spirkenhof.at
          </p>
          <p style={{ ...styles.footerText, marginTop: '1rem', opacity: 0.5, fontSize: '0.8rem' }}>
            <Link to="/impressum" style={styles.footerLink}>Impressum</Link>
            {' · '}
            <Link to="/datenschutz" style={styles.footerLink}>Datenschutz</Link>
          </p>
        </div>
      </footer>
    </main>
  );
}

const F = "'Inter', system-ui, sans-serif";

const styles = {
  loading: { textAlign: 'center', padding: '6rem 2rem', fontFamily: F, color: '#1e8449', fontSize: '1rem' },
  errorBox: { textAlign: 'center', padding: '4rem 2rem', fontFamily: F, color: '#dc3545' },

  contactSection: { backgroundColor: 'white', padding: '5rem 1.5rem', borderTop: '1px solid #e5e7eb' },
  contactInner: { maxWidth: '960px', margin: '0 auto' },
  contactCard: { backgroundColor: '#f8f9fa', borderRadius: '12px', padding: '2.5rem', border: '1px solid #e5e7eb' },
  contactHeading: { color: '#1a1a1a', fontFamily: F, fontSize: '1.8rem', fontWeight: '700', marginBottom: '2rem', textAlign: 'center', letterSpacing: '-0.3px' },
  contactGrid: { display: 'flex', gap: '2.5rem', flexWrap: 'wrap', justifyContent: 'center' },
  contactInfo: { display: 'flex', flexDirection: 'column', gap: '1.1rem', flex: '1 1 260px' },
  contactRow: { display: 'flex', gap: '0.85rem', alignItems: 'flex-start' },
  contactIcon: { fontSize: '1.1rem', flexShrink: 0, marginTop: '0.15rem' },
  contactLabel: { display: 'block', fontFamily: F, fontWeight: '600', color: '#1a1a1a', fontSize: '0.85rem' },
  contactValue: { display: 'block', fontFamily: F, color: '#6b7280', fontSize: '0.92rem', marginTop: '0.1rem' },
  contactLink: { display: 'block', fontFamily: F, color: '#1e8449', fontSize: '0.92rem', textDecoration: 'none', fontWeight: '500', marginTop: '0.1rem' },
  ctaBox: { flex: '1 1 220px', display: 'flex', flexDirection: 'column', gap: '0.75rem', justifyContent: 'center', alignItems: 'stretch' },
  ctaText: { color: '#6b7280', fontFamily: F, textAlign: 'center', fontSize: '0.9rem', fontWeight: '500', marginBottom: '0.2rem' },
  ctaBtn: { display: 'block', backgroundColor: '#1e8449', color: 'white', textDecoration: 'none', padding: '0.85rem 1.5rem', borderRadius: '8px', fontWeight: '600', fontFamily: F, fontSize: '0.95rem', textAlign: 'center' },
  ctaBtnSecondary: { display: 'block', backgroundColor: 'transparent', color: '#1e8449', textDecoration: 'none', padding: '0.82rem 1.5rem', borderRadius: '8px', fontWeight: '500', fontFamily: F, fontSize: '0.9rem', textAlign: 'center', border: '1.5px solid #e5e7eb' },

  footer: { backgroundColor: '#111827', padding: '2rem 1.5rem' },
  footerInner: { maxWidth: '1100px', margin: '0 auto', textAlign: 'center' },
  footerText: { color: 'rgba(255,255,255,0.5)', fontFamily: F, fontSize: '0.85rem' },
  footerLink: { color: 'rgba(255,255,255,0.65)', textDecoration: 'none' },
};
